import styled from "styled-components"
import {hoverRaise} from "@irati/ui/src/global/css/animations"

export default styled.div`
  /* Allow translate to expand somewhere + don't cut shadows */
  margin-top: ${({theme}) => theme.spacing.two};
  margin-bottom: ${({theme}) => theme.spacing.two};
  text-align: left;
  transition:
    transform 0.24s,
    box-shadow 0.24s;
  border-radius: 3px;
  ${hoverRaise}
`
